var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#FFD6DB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2935_25700)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5614 20.0614C20.3099 19.3129 21.5234 19.3129 22.272 20.0614L30.5 28.2894L38.728 20.0614C39.4765 19.3129 40.6901 19.3129 41.4386 20.0614C42.1871 20.8099 42.1871 22.0234 41.4386 22.772L33.2106 31L41.4386 39.228C42.1871 39.9765 42.1871 41.1901 41.4386 41.9386C40.6901 42.6871 39.4765 42.6871 38.728 41.9386L30.5 33.7106L22.272 41.9386C21.5234 42.6871 20.3099 42.6871 19.5614 41.9386C18.8129 41.1901 18.8129 39.9765 19.5614 39.228L27.7894 31L19.5614 22.772C18.8129 22.0234 18.8129 20.8099 19.5614 20.0614Z",
    fill: "#DB1F35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2935_25700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.5714,
    height: 28.5714,
    fill: "white",
    transform: "translate(15.7148 16.2144)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.9de83045f5de7988692ab6219e97849b.svg";
export { ForwardRef as ReactComponent };